export interface NormalizedWord {
  raw: string;
  displayText: string;
  normalizedText: string;
}

const MEANINGFUL_PUNCTUATION = /['’-]/g;

export function normalizeWordInput(raw: string): NormalizedWord {
  const displayText = raw.trim().replace(/\s+/g, " ");
  return {
    raw,
    displayText,
    normalizedText: displayText.toLowerCase(),
  };
}

export function isUsableWord(normalized: NormalizedWord): boolean {
  if (!normalized.normalizedText) {
    return false;
  }
  const letters = normalized.normalizedText.replace(MEANINGFUL_PUNCTUATION, "").replace(/\s+/g, "");
  return /[a-z]/i.test(letters);
}

export function normalizeAnswer(value: string): string {
  return value.trim().replace(/\s+/g, " ").toLowerCase();
}

export function answersMatch(given: string, accepted: readonly string[]): boolean {
  const normalized = normalizeAnswer(given);
  return accepted.some((item) => normalizeAnswer(item) === normalized);
}
